import { render, staticRenderFns } from "./TranServicePackageUpdate.vue?vue&type=template&id=7487cac4&scoped=true"
import script from "./TranServicePackageUpdate.vue?vue&type=script&lang=js"
export * from "./TranServicePackageUpdate.vue?vue&type=script&lang=js"
import style0 from "./TranServicePackageUpdate.vue?vue&type=style&index=0&id=7487cac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7487cac4",
  null
  
)

export default component.exports